import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('returns', 'trả hàng');

const state = {
    ...crud.state,
    by_products: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getListByProduct({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('returns/by_product', data => {
            commit('setListByProduct', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setListByProduct(state, data) {
        state.by_products = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};